import { tickerItems, homeStats } from "@/mocks/site";

const trendTone: Record<string, string> = {
  反转: "bg-accent-500 text-accent-950",
  升温: "bg-accent-200 text-accent-900",
  回落: "bg-primary-100 text-primary-800",
  待定: "bg-background-200 text-foreground-700",
};

export default function WindSection() {
  const sorted = [...tickerItems].sort((a, b) => b.heat - a.heat);

  return (
    <section id="wind" className="scroll-mt-12 w-full border-b border-background-200 py-12 md:py-16">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-[11px] font-medium tracking-[0.24em] text-secondary-500">WIND DIRECTION</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">风向速览</h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
              热度不等于真相，但热度会先于真相到达。下面这些是过去 72 小时内出现明显方向变化的事件，
              我们按热度排序，并标注它此刻正在往哪个方向走。
            </p>
          </div>
          <div className="flex shrink-0 gap-6 border-l border-background-300 pl-6">
            <div>
              <p className="font-heading text-xl font-bold text-foreground-950">{homeStats[0].value}</p>
              <p className="mt-1 text-[11px] text-foreground-500">累计归档</p>
            </div>
            <div>
              <p className="font-heading text-xl font-bold text-accent-600">8</p>
              <p className="mt-1 text-[11px] text-foreground-500">正在观察中</p>
            </div>
          </div>
        </div>

        <ul className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {sorted.map((item) => (
            <li
              key={item.label}
              className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-4"
            >
              <div className="flex items-center justify-between gap-2">
                <span
                  className={`inline-flex items-center whitespace-nowrap rounded-md px-2 py-1 text-[11px] font-medium ${
                    trendTone[item.trend] ?? "bg-background-200 text-foreground-700"
                  }`}
                >
                  {item.trend}
                </span>
                <span className="font-heading text-lg font-bold text-foreground-900">{item.heat}</span>
              </div>
              <h3 className="font-heading text-sm font-semibold leading-snug text-foreground-950">{item.label}</h3>
              <p className="text-xs leading-relaxed text-foreground-600">{item.note}</p>
              <div className="mt-auto h-1 w-full overflow-hidden rounded-full bg-background-200">
                <div
                  className="h-1 rounded-full bg-accent-500"
                  style={{ width: `${item.heat}%` }}
                  aria-hidden="true"
                />
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}